import React from "react";

const LOGO_SRC = "/gaelon-logo.png";

// Compact mark — just the "G" portion of the official logo (square crop).
// We use objectPosition/clip to display the left ~40% of the lockup.
export const LogoMark = ({ size = 32, className = "" }) => {
  return (
    <span
      className={"inline-block overflow-hidden align-middle " + className}
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      <img
        src={LOGO_SRC}
        alt=""
        draggable={false}
        style={{
          // The PNG is roughly square with the "G" occupying the left ~38%.
          // Scale up and offset so only the G shows inside the square box.
          height: size,
          width: size * (1 / 0.38),
          objectFit: "cover",
          objectPosition: "left center",
          display: "block",
          maxWidth: "none",
        }}
      />
    </span>
  );
};

// Full official logo lockup (image-based).
export const LogoLockup = ({ height = 28, className = "" }) => {
  return (
    <img
      src={LOGO_SRC}
      alt="GAELON — Intelligence, Automation, Impact"
      draggable={false}
      className={"block select-none " + className}
      style={{ height, width: "auto" }}
    />
  );
};

export default LogoLockup;
